import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.for-each.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.array.push.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.map.constructor.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.entries.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.string.iterator.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.for-each.js';
import '../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/web.dom-collections.iterator.js';
import { __rest, __assign } from '../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import { isMap, isObject } from 'lodash';
import transText from './transText.js';

// todo 完善类型
var transMapValueEnum = function transMapValueEnum(valueEnum) {
  var columns = [];
  if (!isMap(valueEnum)) {
    return columns;
  }
  valueEnum.forEach(function (v, k) {
    if (v === null || v === void 0 ? void 0 : v.text) {
      v.text;
        var rest = __rest(v, ["text"]);
      var column = __assign({
        label: transText(v, undefined),
        value: k
      }, rest);
      columns.push(column);
    } else {
      columns.push({
        label: v,
        value: k
      });
    }
  });
  return columns;
};
// todo 完善类型
var transObjectValueEnum = function transObjectValueEnum(valueEnum) {
  var columns = [];
  if (!isObject(valueEnum)) {
    return columns;
  }
  return transMapValueEnum(new Map(Object.entries(valueEnum)));
};

export { transMapValueEnum, transObjectValueEnum };
